import { ApolloLink } from 'apollo-link';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(globalThis as any).activeRequestsCount = 0;

export default new ApolloLink((operation, forward) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (globalThis as any).activeRequestsCount++;

  return forward(operation).map(response => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (globalThis as any).activeRequestsCount--;

    return response;
  });
});
